<mat-toolbar class="header-shadow relative z-50 bg-white !flex-col sm:!flex-row">
  <section class="py-2 lg:px-6 flex justify-between items-center w-full h-full">
    <!-- links -->
    <div class="flex items-center gap-1 lg:gap-3 text-xs lg:text-base">
      <a href="/">
        <img class="hidden lg:inline logo" ngSrc="/assets/images/text_logo.png" alt="Monisfer logo" width="200" height="60" priority />
        <img class="inline lg:hidden logo" ngSrc="/assets/images/only-icon_logo.png" alt="Monisfer logo" width="60" height="60" priority />
      </a>

      <div class="hidden sm:flex text-[11px] md:text-base gap-1">
        <ng-container [ngTemplateOutlet]="SectionLinksDesktopMode"></ng-container>
      </div>
      <div class="flex items-center gap-1 sm:hidden">
        <ng-container [ngTemplateOutlet]="SectionLinkMobileMode"></ng-container>
      </div>
    </div>
    <!-- logged in mode  -->
    @let user = authService.user$ | async;
    @if (user != null) {
      <div class="flex items-center gap-1">
        <button mat-fab class="!shadow-none" color="water">
          <mat-icon> notifications</mat-icon>
        </button>
        <button mat-fab class="!shadow-none" color="water" [matMenuTriggerFor]="ProfileMenu">
          @if (user.avatar) {
            <img [src]="user.avatar" alt="user avatar" class="rounded-full !h-12 !w-12" />
          } @else {
            <mat-icon>person</mat-icon>
          }
          <mat-menu class="profile-menu w-[375px]" #ProfileMenu="matMenu">
            <ng-container [ngTemplateOutlet]="ProfileMenuItemUsername" [ngTemplateOutletContext]="{ user: user }"></ng-container>
            <ng-container
              [ngTemplateOutlet]="ProfileMenuItemBtn"
              [ngTemplateOutletContext]="{
                user: user,
                icon: 'account_circle_outline',
                iconColor: '!text-green-500',
                title: 'My Profile',
                desc: 'Personal Information',
                link: '/user/profile',
              }"
            >
            </ng-container>
            <ng-container
              [ngTemplateOutlet]="ProfileMenuItemBtn"
              [ngTemplateOutletContext]="{
                user: user,
                icon: 'currency_exchange',
                iconColor: '!text-blue-500',
                title: 'My Transactions',
                desc: 'Status & Recipes',
                link: '/user/transactions',
              }"
            >
            </ng-container>
            <ng-container
              [ngTemplateOutlet]="ProfileMenuItemBtn"
              [ngTemplateOutletContext]="{
                user: user,
                icon: 'contacts',
                iconColor: '!text-yellow-500',
                title: 'My Contacts',
                desc: 'Send & Receive Money',
                link: '/user/contacts',
              }"
            >
            </ng-container>
            <ng-container
              [ngTemplateOutlet]="ProfileMenuItemBtn"
              [ngTemplateOutletContext]="{
                user: user,
                icon: 'fingerprint',
                iconColor: '!text-fuchsia-500',
                title: 'My Authentication',
                desc: 'Identity Information',
                link: '/user/authentication',
              }"
            >
            </ng-container>
            <ng-container
              [ngTemplateOutlet]="ProfileMenuItemBtn"
              [ngTemplateOutletContext]="{
                user: user,
                icon: 'notifications',
                iconColor: '!text-amber-500',
                title: 'My Rate Alerts',
                desc: 'List of all rate alerts',
                link: '/user/alerts',
              }"
            >
            </ng-container>
            <button mat-menu-item class="w-full" (click)="authService.logout()">
              <!-- <div class="text-red-400 text-center  lh-60px">
                                LOG OUT
                            </div> -->
              <div class="flex items-center gap-1">
                <div class="w-[50px] h-[50px] flex justify-center items-center rounded-full">
                  <mat-icon class="!text-red-500">logout</mat-icon>
                </div>
                <span>
                  <p class="font-bold">LOGOUT</p>
                  <small class="text-gray-300">Terminate Current Session</small>
                </span>
              </div>
            </button>
          </mat-menu>
        </button>
      </div>
    } @else {
      <a class="lh-[--btn-height] !h-[--btn-height]" mat-raised-button color="primary" (click)="authService.openDialog()"> LOGIN/REGISTER </a>
    }
  </section>
</mat-toolbar>

<!-- menu items templates -->
<ng-template #ProfileMenuItemUsername let-user="user">
  <button class="pointer-events-none w-full h-[50px] !justify-center !bg-gray-400 !text-white">
    <div class="flex justify-center items-center gap-2">
      <div class="w-[40px] h-[40px] flex justify-center items-center bg-neptune rounded-full">
        @if (user.avatar) {
          <img [src]="user.avatar" alt="user avatar" class="!h-11 !w-11 rounded-full border-2 border-gray-200" />
        } @else {
          <mat-icon class="!text-white !mr-0" fontIcon="person_outline"></mat-icon>
        }
      </div>
      <span>{{ user?.username }}</span>
    </div>
  </button>
</ng-template>
<ng-template #ProfileMenuItemBtn let-user="user" let-icon="icon" let-iconColor="iconColor" let-title="title" let-description="desc" let-link="link">
  <button mat-menu-item [routerLink]="link">
    <div class="flex items-center gap-1">
      <div class="w-[50px] h-[50px] flex justify-center items-center rounded-full">
        <mat-icon [class]="iconColor">{{ icon }}</mat-icon>
      </div>
      <span>
        <p class="font-bold">{{ title }}</p>
        <small class="text-gray-300">{{ description }}</small>
      </span>
    </div>
    <div>
      <mat-icon class="!text-gray-500 !mr-0">keyboard_arrow_right</mat-icon>
    </div>
  </button>
</ng-template>
<!-- end menu items templates -->

<!-- links section -->
<!-- desktop mode -->
<ng-template #SectionLinksDesktopMode>
  <a class="menu-btn" routerLink="/" fragment="home" routerLinkActive="menu-btn_active" [routerLinkActiveOptions]="routerLinkOptions"> HOME </a>
  <a class="menu-btn" routerLink="/" fragment="currency-rates" routerLinkActive="menu-btn_active" [routerLinkActiveOptions]="routerLinkOptions"> CURRENCY RATES </a>
  <a class="menu-btn" routerLink="/" fragment="why-choose-us" routerLinkActive="menu-btn_active" [routerLinkActiveOptions]="routerLinkOptions"> WHY CHOOSE US </a>
  <a class="menu-btn" routerLink="/" fragment="how-it-works" routerLinkActive="menu-btn_active" [routerLinkActiveOptions]="routerLinkOptions"> HOW IT WORKS </a>
</ng-template>
<!-- mobile mode -->
<ng-template #SectionLinkMobileMode>
  <a class="menu-btn" routerLink="/" routerLinkActive="menu-btn_active" [routerLinkActiveOptions]="{ exact: true }"> HOME </a>
  <button mat-mini-fab class="!shadow-none" color="whitesmoke" [matMenuTriggerFor]="LinksMenu">
    <mat-icon fontIcon="more_horiz"></mat-icon>
    <mat-menu class="links-menu w-[200px]" #LinksMenu="matMenu">
      <a
        class="menu-btn w-full !leading-[60px]"
        routerLink="/"
        fragment="currency-rates"
        routerLinkActive="menu-btn_active"
        [routerLinkActiveOptions]="routerLinkOptions"
      >
        CURRENCY RATES
      </a>
      <a class="menu-btn w-full !leading-[60px]" routerLink="/" fragment="why-choose-us" routerLinkActive="menu-btn_active" [routerLinkActiveOptions]="routerLinkOptions">
        WHY CHOOSE US
      </a>
      <a class="menu-btn w-full !leading-[60px]" routerLink="/" fragment="how-it-works" routerLinkActive="menu-btn_active" [routerLinkActiveOptions]="routerLinkOptions">
        HOW IT WORKS
      </a>
    </mat-menu>
  </button>
</ng-template>
<!-- end links -->
